import { render, staticRenderFns } from "./CountryTimeClock.vue?vue&type=template&id=2a08e6f1&scoped=true&"
import script from "./CountryTimeClock.vue?vue&type=script&lang=js&"
export * from "./CountryTimeClock.vue?vue&type=script&lang=js&"
import style0 from "./CountryTimeClock.vue?vue&type=style&index=0&id=2a08e6f1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a08e6f1",
  null
  
)

export default component.exports